import { URL_SERVICE } from "../utils/api-constants";
import { axiosInstance } from './axios-instance';

class NotificationServices {

    static sendNotification(payload) {
        return axiosInstance.post(URL_SERVICE + "/api/v1/notification", payload)
            .then(resp => resp.data);
    }
}

export default NotificationServices;